// @mui
import { Stack, InputAdornment, TextField } from '@mui/material';
import Iconify from 'components/Iconify';
import { t } from 'i18next';
// components

// ----------------------------------------------------------------------

type Props = {
  filterName: string;
  onFilterName: (value: string) => void;
  placeholder?: string;
};

export default function ProductTableToolbar({
  filterName,
  onFilterName,
  placeholder,
}: Props) {
  return (
    <Stack
      alignItems='center'
      justifyContent='space-between'
      sx={{ py: 2.5, px: 3 }}
    >
      <TextField
        value={filterName}
        onChange={event => onFilterName(event.target.value)}
        placeholder={placeholder}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <Iconify
                icon={'eva:search-fill'}
                sx={{ color: 'text.disabled', width: 20, height: 20 }}
              />
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  );
}
